// extracted by mini-css-extract-plugin
export var quantityInput = "_dv-0";